import React from 'react';
import HoloCard from '../components/HoloCard';
import SafeIcon from '../common/SafeIcon';

const PlaceholderPage = ({ title, description }) => {
  return (
    <div className="h-full flex flex-col items-center justify-center space-y-6 text-center">
      <div className="w-24 h-24 rounded-full border-2 border-dashed border-cyan-800 flex items-center justify-center animate-[spin_10s_linear_infinite]">
        <SafeIcon name="Cpu" className="text-4xl text-cyan-900" />
      </div>
      <div>
        <h1 className="text-2xl font-light text-white tracking-wide">{title}</h1>
        <p className="text-slate-500 text-sm mt-2 max-w-md mx-auto">{description}</p>
      </div>
      <HoloCard className="w-96 mt-8">
        <div className="flex items-center space-x-3 text-amber-500/80 justify-center">
          <SafeIcon name="AlertCircle" />
          <span className="text-sm font-mono">Module currently undergoing maintenance</span>
        </div>
      </HoloCard>
    </div>
  );
};

export default PlaceholderPage;